// src/assets/components/HeaderTab.jsx
import React from "react";
import red from "../icons/warning/danger.svg";

/**
 * HeaderIconL 바로 아래에 쓰는 탭 바
 *
 * props
 * - tabs: [{ key, label, hasIcon? }]
 * - activeTab: 현재 선택된 key
 * - onChange: (key) => void
 * - className: 바 전체에 추가할 클래스
 * - icon: 우측 상단 빨간 점 아이콘 (기본: danger.svg)
 */
export function HeaderTab({
  tabs = [],
  activeTab,
  onChange,
  className = "",
  icon = red,
}) {
  return (
    <div
      className={`flex border-b border-border-subtle ${className}`}
    >
      {tabs.map((tab) => {
        const isActive = tab.key === activeTab;
        const hasIcon = !!tab.hasIcon;

        return (
          <button
            key={tab.key}
            type="button"
            onClick={() => onChange && onChange(tab.key)}
            className={`relative flex-1 pt-[8px] pb-[10px] text-center bg-surface-light-white border-b-2 ${isActive
              ? "border-border-primary text-text-primary text-t4"
              : "border-transparent text-text-subtler text-b1"
              }`}
          >
            <div className="flex justify-center">
              <span className="relative inline-block text-center">
                {tab.label}
                {hasIcon && (
                  <img
                    src={icon}
                    alt="icon"
                    className="w-[4px] h-[4px] absolute -right-[8px] top-[4px]"
                  />
                )}
              </span>
            </div>
          </button>
        );
      })}
    </div>
  );
}
